import * as React from 'react';

// PACKAGES
import { Link } from 'react-router-dom';

// COMPONENTS
import CircleImage from '../../components/CircleImage';
import DisplayDateTime from '../../components/DisplayDateTime';
import DisplayTimeFromNow from '../../components/DisplayTimeFromNow';

interface RequestsToJoinItemTypes {
	id?: string;
	firstName?: string;
	lastName?: string;
	image?: string;
	organisationRole?: string[];
	timeRequested?: string;
	role: string;
}
import { ExtraDomainProfileType } from '../../Interfaces';
import { DomainProfileType } from '../../api/models';

const RequestsToJoinItem: React.FC<RequestsToJoinItemTypes> = ({
	id,
	firstName,
	lastName,
	image,
	timeRequested,
	role
}) => {
	return (
		<div className="grid-list-row" key={id}>
			<div className="grid-list-row__inner">
				<div className="grid-cell-icon">
					<CircleImage src={image} size={40} firstName={firstName} lastName={lastName} />
				</div>

				<div className="grid-cell-name">
					{firstName} {lastName}
				</div>

				<div className="grid-cell-date">
					<span className="title">Date Requested</span>

					<span className="status">
						<DisplayDateTime>{timeRequested}</DisplayDateTime>
					</span>
				</div>

				<div className="grid-cell-time">
					<span className="status">
						<DisplayTimeFromNow>{timeRequested}</DisplayTimeFromNow>
					</span>
				</div>

				<div className="grid-cell-action">
					<Link
						className="btn-text pdl-0-mobile"
						to={{
							pathname: `/requests-to-join/${id}`,
							state: {
								isStaff:
									role === DomainProfileType.Staff || role === DomainProfileType.SuperAdministrator ? true : false,
								volunteer: role === ExtraDomainProfileType.ParentVolunteer ? true : false
							}
						}}
					>
						View
					</Link>
				</div>
			</div>
		</div>
	);
};

export default RequestsToJoinItem;
